.field-wrapper-container {
    width: 100%;
    position: relative;
}
